import React from 'react'

const SocialMediaMarketing = () => {
  const serviceData = {
  hero: {
    heading: <>SOCIAL MEDIA<br/> MARKETING</>,
  },
  section1: {
    description:
      <><b> Unlocking Growth with Google Ads, Meta Ads, and Instagram Ads</b><br/>
In the digital age, social media marketing has become an indispensable growth engine for businesses of all sizes. By leveraging platforms such as Google Ads, Meta Ads (Facebook and Instagram), and Instagram Ads, companies can strategically reach, engage, and convert their ideal customers in ways never before possible. Our comprehensive social media marketing services combine creativity, data-driven insights, and advanced targeting technologies to deliver powerful, ROI-focused campaigns tailored to your business goals.
</>,
      title1: "Why Social Media Marketing Matters",
      description1: 'Social media platforms are where billions of people spend a significant portion of their time—making them fertile ground for meaningful brand interactions and customer acquisition. Leading digital marketing agencies worldwide agree that social media marketing is essential because it enables',
    image: "/socialmarketingimg1.webp",
  points: [
      {
        head: "Precision Targeting ",
        text: "Advanced algorithms on Google and Meta platforms allow laser-focused targeting based on demographics, interests, behaviors, and search intent.",
      },
      {
        head: "Engagement at Scale",
        text: "Social media offers interactive formats like videos, carousel ads, and stories that foster deeper emotional connections with audiences.",
      },
      {
        head: "Real-Time Optimization",
        text: "Campaigns can be adjusted dynamically with performance data, ensuring every ad dollar is maximized",
      },
      {
        head: "Brand Building and Awareness",
        text: "Consistent presence on popular platforms develops brand familiarity and trust over time",
      },
      {
        head: "Multi-Channel Synergy",
        text: "Integrating Google Ads with Meta’s social ecosystem creates powerful cross-channel marketing funnels",
      },
    ],
  },
}
  return (
    <>
        <div className="services-hero">
          <div className='sem-hero-img'>
        
          <div className="overlay"></div>
          <div className="hero-content">
            <h2 className="hero_heading">{serviceData.hero.heading}</h2>
          </div>
          </div>
        </div>

          <div className="backdiv">
      
        <div className="servicepage_grid">
        <div>
  <p className='main_content'>{serviceData.section1.description}</p>
        </div>
          <div>
            <div className="servicepage_imgdiv">
              <img
                src={serviceData.section1.image}
                alt="Web Development"
                className="zweedo_img"
                loading="lazy"
              />
            </div>
          </div>

        </div>
          <div>
             <h2 className='main_heading'>{serviceData.section1.title1}</h2>
            
            <div className="servicepage_textdiv">
              {serviceData.section1.points.map((point, index) => (
                  <div key={index} className="service_point">
                    <h4 className="point_head">{point.head}</h4>
                    <p className="point_text">{point.text}</p>
                  </div>
                ))}
            </div>
          </div>
      </div>
    </>
  )
}

export default SocialMediaMarketing